import { render, staticRenderFns } from "./LiaGenelationContacts.vue?vue&type=template&id=2310c9c9&scoped=true"
import script from "./LiaGenelationContacts.vue?vue&type=script&lang=js"
export * from "./LiaGenelationContacts.vue?vue&type=script&lang=js"
import style0 from "./LiaGenelationContacts.vue?vue&type=style&index=0&id=2310c9c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2310c9c9",
  null
  
)

export default component.exports